import { useState } from "react"
import useAptNavigation from "./use-apt-navigation"
import { langStore } from "../../../stores/lang-store"
import { useMemo } from "react"
import { Fragment } from "react"
import { navBundle } from "@/routes/_layout/nav/nav-const"

const BottomBar = ({ mainRef }) => {
  const { lang } = langStore()
  const [activeGroup, setActiveGroup] = useState(null)

  const { section, resource, goPage, goResource, isResourceVisible } = useAptNavigation()

  const scrollToTop = () => {
    if (!mainRef?.current) return

    mainRef.current.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  }

  const tabClick = (nav) => {
    if (nav.type === "group") {
      setActiveGroup(nav)
      return
    }

    goPage(nav.id)
    scrollToTop()
    setActiveGroup(null)
  }

  const resourceClick = (resource) => {
    goResource(activeGroup.id, resource)
    setActiveGroup(null)
  }

  const items = useMemo(() => {
    return navBundle.navs
      .map((nav) => {
        const active = nav.type === "group" ? section === nav.id : section === nav.id

        return {
          ...nav,
          active
        }
      })
      .filter((nav) => nav.id !== "monitoring") // ! 모바일에 적합하지 않음
  }, [section])

  return (
    <>
      {activeGroup && (
        <div
          className="fixed inset-0 h-[calc(100vh-45px)] bottom-full z-40 bg-black/30"
          onClick={() => setActiveGroup(null)}
        >
          <div
            className="absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl p-3"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="h-1 w-10 bg-slate-200 rounded-full mx-auto mb-4" />

            <h3 className="text-center font-semibold mb-4">{activeGroup.label[lang]}</h3>

            <div className="flex flex-col gap-2">
              {activeGroup.children.map((c) => {
                const active = section === activeGroup.id && resource === c.id

                if (!isResourceVisible(c.id)) {
                  return <Fragment key={c.id} />
                }

                return (
                  <button
                    key={c.id}
                    onClick={() => resourceClick(c.id)}
                    className={`w-full py-3 rounded-xl text-sm font-semibold transition ${
                      active
                        ? "text-slate-900 border-toicos-navy border-2 bg-blue-50"
                        : "text-slate-500 border border-slate-200"
                    }`}
                  >
                    {c.label[lang]}
                  </button>
                )
              })}
            </div>
          </div>
        </div>
      )}

      <nav className="bg-white border-t border-slate-100 relative z-30">
        <div
          className="grid"
          style={{
            gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))`
          }}
        >
          {items.map((item) => {
            const Icon = item.icon

            return (
              <button
                key={item.id}
                onClick={() => tabClick(item)}
                className={`flex flex-col items-center justify-center gap-1 py-2 transition ${
                  item.active ? "text-slate-900" : "text-slate-400"
                }`}
              >
                {Icon && (
                  <Icon size={18} className={item.active ? "text-slate-900" : "text-slate-400"} />
                )}

                <span className="text-xs font-medium">{item.label[lang]}</span>
              </button>
            )
          })}
        </div>
      </nav>
    </>
  )
}

export default BottomBar
